import React, { useState, useEffect, useCallback } from 'react';
import { ScreenCard } from 'components/customComponents/Layers/InputGroups';
import { ReactComponent as PlusCircle } from 'Icons/PlusCircle.svg';
import ELayersView from 'enums/ELayersView';
import { isNullOrUndefined } from 'utils/Global';
import { usePreserveExperiment, useRMDispatch, useRMSelector } from 'redux/hooks';
import RMButton from 'components/customComponents/Controls/RMButton';
import { ScreenLayerDTO } from 'business/models/Models';
import ExperimentDtoClient from 'business/models/ExperimentDtoClient';
import { getExpWells } from 'business/plateviewer/Generate/GenerateCommon';
import {
  selectIsEditable,
  selectIsModifyAccessRights,
} from 'redux/selectors/StateSelectors';
import { updateExperimentLayers } from 'redux/reducers/experimentDataReducer';
import {
  selectExperimentLayers,
  selectSelectedLayer,
} from 'redux/selectors/ExperimentStateSelector';
import { cloneDeep } from 'lodash';
import { FmlxButton } from 'fmlx-common-ui';
import { useAllowLayerEditing } from 'redux/hooks/experiment';

export type ScreenLayerContentProps = {
  setContentView: any;
  setEditScreenData?: any;
};
export function ScreenLayerContent({
  setContentView,
  setEditScreenData,
}: ScreenLayerContentProps) {
  const dispatch = useRMDispatch();
  const _layers = useRMSelector(selectExperimentLayers);
  const _selectedLayer = useRMSelector(selectSelectedLayer);
  const _setLayers = useCallback(
    (lyrs) => dispatch(updateExperimentLayers(lyrs)),
    [dispatch],
  );
  const [screenLayer, setScreenLayer] = useState<ScreenLayerDTO>();
  const isEditMode: boolean = useRMSelector(selectIsEditable);
  const modifyAccessRights: boolean = useRMSelector(selectIsModifyAccessRights);
  const callPreserveUndoableState = usePreserveExperiment();
  const isLayerEditingAllowed = useAllowLayerEditing();

  useEffect(() => {
    setScreenLayer({ ..._selectedLayer.layerDetail } as ScreenLayerDTO);
  }, [_selectedLayer]);

  function addScreen() {
    setContentView(ELayersView.SELECTSCREEN);
  }

  function onEditScreen() {
    setContentView(ELayersView.EDITSCREEN);
  }
  function onDeleteScreen() {
    callPreserveUndoableState();
    screenLayer.screenLot = undefined;
    const index = _layers.findIndex((l) => l.id == _selectedLayer.id);
    const tempLayers = cloneDeep(_layers);
    tempLayers[index].layerDetail = screenLayer;
    tempLayers[index].dirty = true;
    _setLayers(tempLayers);
  }

  function getScreenCardView() {
    if (isNullOrUndefined(screenLayer)) {
      return null;
    }
    if (isNullOrUndefined(screenLayer.screenLot)) {
      return null;
    }
    if (isNullOrUndefined(screenLayer.screenLot.experiment)) {
      return null;
    }

    const screenName = screenLayer.screenLot.experiment.expName;
    const lotComments = screenLayer.screenLot.initialLot
      ? 'Default Lot'
      : screenLayer.screenLot.lotNumber.toString();
    const conditions = getExpWells(
      screenLayer.screenLot.experiment as ExperimentDtoClient,
    ).length;
    const lyrConditions = (_selectedLayer.width + 1) * (_selectedLayer.height + 1);
    return (
      <ScreenCard
        screenName={screenName}
        lotComments={lotComments}
        conditions={conditions}
        usedConditions={lyrConditions}
        customStyle={{
          marginTop: '5px',
          border: 'none',
          borderTop: '1px solid #BFBFBF',
          borderRadius: '0px',
        }}
        isEditMode={isEditMode && modifyAccessRights && isLayerEditingAllowed}
        onEditScreen={onEditScreen}
        onDeleteScreen={onDeleteScreen}
      />
    );
  }
  return (
    <>
      {(isNullOrUndefined(screenLayer) || isNullOrUndefined(screenLayer.screenLot)) &&
        isEditMode &&
        modifyAccessRights &&
        isLayerEditingAllowed && (
          <RMButton
            Icon={
              <PlusCircle id="commandpanel-screenlayer-content-add-button"
                style={{ height: '1.5rem', width: '1.5rem', marginRight: '0.44rem' }}
              />
            }
            customStyle={{
              width: '14.81rem',
              height: '3rem',
              maxHeight: '3rem',
              minHeight: '3rem',
              borderRadius: '0.5rem',
              fontSize: '1.25rem',
              lineHeight: '1.45rem',
            }}
            onClick={addScreen}
            label={'Add Screen'}
            withIcon={FmlxButton.WithIcon.START}
            type={FmlxButton.Type.POSITIVE}
          ></RMButton>
        )}
      <div id="commandpanel-screenlayer-content-card-view" className="h-[45vh] w-full overflow-y-auto overflow-x-hidden">
        {getScreenCardView()}
      </div>
    </>
  );
}
